module.exports = __webpack_public_path__ + "img/cnn2.9de921e8.png";